export default __webpack_public_path__ + "static/media/mr_mrs_smith_l1.1f64c128.png";